import { usePorwerBI } from './usePowerBI'

export default usePorwerBI
